"use strict";

/* eslint-disable no-unused-vars */
function handleCallOfferSubmit(token, formId) {
  var form = document.querySelector("#".concat(formId));
  var formButton = form.querySelector("button");
  if (formButton.classList.contains("loading")) {
    return;
  }
  formButton.classList.add("loading");
  var formData = new FormData(form);
  var formProps = Object.fromEntries(formData);
  var invalid = false;
  ["name", "phone", "agree"].forEach(function (input) {
    if (!formProps[input]) {
      form.querySelector("[name=".concat(input, "]")).setAttribute("error", "");
      invalid = true;
    }
  });
  if (invalid) {
    formButton.classList.remove("loading");
    return;
  }

  // eslint-disable-next-line no-undef
  fetch("".concat(settings.templateDir, "/post/call-offer.php"), {
    credentials: "same-origin",
    mode: "same-origin",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formProps)
  }).then(function (resp) {
    if (resp.status === 200) {
      return resp.json();
    } else {
      form.querySelector(".result-text").innerText = "Kunne ikke udføre anmodningen. Ring venligst direkte til os i stedet.";
      form.classList.add("text-red-600");
      return Promise.reject("server");
    }
  }).then(function () {
    form.innerHTML = "\n      <div class=\"text-4xl font-extrabold\">Tak for din henvendelse!</div>\n      <div>Vi kontakter dig hurtigst muligt.</div>\n      ";
    form.classList.add("py-12");
  }).catch(function (err) {
    if (err === "server") return;
    console.log(err);
  });
}
function onCallOfferCheckboxChange(e) {
  e.target.removeAttribute("error");
}
function onCallOfferInputFocus(e) {
  e.target.removeAttribute("error");
}
//# sourceMappingURL=callOffer.js.map